<template>
  <div style="display:flex;align-items:center;gap:0;font-family:var(--ff-head);font-size:12px;">
    <template v-for="(it, i) in items" :key="it.id">
      <div :style="itemStyle(i)">
        <div :style="dotStyle(i)">{{ isDone(i) ? '✓' : i + 1 }}</div>
        {{ it.label }}
      </div>
      <div v-if="i < items.length - 1" style="width:24px;height:1px;background:var(--border-strong);margin:0 10px;" />
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  step: { type: String, required: true },
})

const items = [
  { id: 'cliente',      label: 'Comedores' },
  { id: 'pedido',       label: 'Productos' },
  { id: 'checkout',     label: 'Confirmar' },
  { id: 'confirmacion', label: 'Enviado' },
]

const order = computed(() => items.findIndex(i => i.id === props.step))

const isDone = (i) => i < order.value
const isActive = (i) => i === order.value

function itemStyle(i) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    color: isDone(i) ? 'var(--primary)' : isActive(i) ? 'var(--text)' : 'var(--text-3)',
    fontWeight: isActive(i) ? 700 : 500,
  }
}

function dotStyle(i) {
  return {
    width: '18px',
    height: '18px',
    borderRadius: '999px',
    background: isDone(i) ? 'var(--primary)' : isActive(i) ? 'var(--text)' : 'var(--border-strong)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '10px',
    fontWeight: 700,
  }
}
</script>
